<template>
<div class="popup_wrpr products-list-panel active">
<!--	<div class="popup_wrpr product-settings-popup-wrap active">-->
		<div class="app_settings_popup ">
				<div class="popup_left_side">
					<Loading v-show="loading"/>
					<a href="#" class="close_popup_btn" @click.prevent="close">
						<inline-svg :src="require('@/assets/img/popup_close.svg')"/>
					</a>

					<div class="scroll">
						<!-- STEP CAN HAVE PRODUCTS -->
						<div class=" products_panel" v-if="canHaveProducts">
							<div class="layout-row flex products-header">
								<h2 class="flex layout-row" >Your step products</h2>
								<v-button @click="createProductOpen=true" label="Add a new product"/>
							</div>

							<!-- Orderbump -->
							<div class="panel-body panel-body_2 ordered-body entries-table" v-if="obProducts.length">

								<div class="entry panel-item" v-for="(item, index) in obProducts" :key="item.id" >
	<!-- :to="{ path: `/wfunnel/${$route.params.id}/steps/${$route.params.step}/product/${item.id}`}" -->
									<a class="list-item-link cell" @click="currentProduct=item;productOpen=true">
										<div class="products_panel_first_cell cell">
											<div class="products_panel_square_label">
												<img :src="require('@/assets/img/ob_label.svg')" alt="">
											</div>
										</div>
										<div class="panel-item-cell cell">
											<div class="product_panel_link">{{item.name}}</div>
											<span class="result-tag">
	                      {{item.is_subscription ? 'Subscription' : 'One-time'}}
	                  </span>
										</div>
										<div class="panel-item-cell product-price-cell cell" v-if="item.is_subscription">
											<h3 class="price">{{currencySymbol+' '+item.billing_amount}}</h3>
											<span class="products_panel_weeks">
	                      {{item.billing_cycle}}
	                      {{ getCycleType(item.cycle_type) }}
	                  </span>
										</div>
										<div class="panel-item-cell product-price-cell cell" v-else>
											<h3 class="price">{{currencySymbol+' '+item.price}}</h3>
										</div>
									</a>
									<div class="panel_item_btn_wrpr cell">
										<a @click.prevent="" class="panel_item_btn copy_btn">
											<inline-svg :src="require('@/assets/img/copy_icon.svg')"/>
										</a>
										<a @click.prevent="" class="panel_item_btn delete_btn">
											<inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
										</a>
									</div>
								</div>
							</div>
							<!-- Other products -->
							<div class="panel-body panel-body_2 ordered-body entries-table" v-if="products.length">
								<Container @drop="onDrop" lock-axis="y">
									<Draggable v-for="(item, index) in otherProducts" :key="item.id" class="product-result-item">
										<div class="panel-item entry" :data-order="item.order_index">
	<!--										 :to="{ path: `/wfunnel/${$route.params.id}/steps/${$route.params.step}/product/${item.id}`}" -->
											<a class="list-item-link" @click="currentProduct=item;productOpen=true">
												<div class="products_panel_first_cell">
													<div class="number">#{{index + 1}}</div>
												</div>
												<div class="panel-item-cell">
													<div class="product_panel_link">
														{{item.name}}
													</div>
													<span class="result-tag">
	                            {{item.is_subscription ? 'Subscription' : 'One-time'}}
	                        </span>
												</div>
												<div class="panel-item-cell product-price-cell" v-if="item.is_subscription">
													<h3 class="price">{{ currencySymbol+' '+item.billing_amount }}</h3>
													<span class="products_panel_weeks">
	                            {{item.billing_cycle}}
	                            {{ getCycleType(item.cycle_type) }}
	                        </span>
												</div>
												<div class="panel-item-cell product-price-cell" v-else>
													<h3 class="price">{{currencySymbol+' '+item.price}}</h3>
												</div>
											</a >
											<div class="panel_item_btn_wrpr">
												<a @click.prevent="currentProduct=item;cloneProductPopup=true;" class="panel_item_btn copy_btn">
													<inline-svg :src="require('@/assets/img/copy_icon.svg')"/>
												</a>
												<a @click.prevent="currentProduct=item;deleteProductPopup=true" class="panel_item_btn delete_btn">
													<inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
												</a>
											</div>
										</div>
									</Draggable>
								</Container>
							</div>

							<div class="panel-body panel-body_2 empty-panel" v-else>
								<p>No products have been added yet</p>
							</div>
							<!-- POPUPS -->
							<div class="popup_wrpr delete_popup_wrpr add_new_funnel_popup" :class="{active: deleteProductPopup}">
								<ProductDeletePopup :productId="currentProduct.id" v-if="deleteProductPopup"
								                    @done="productDeleted(currentProduct)" @cancel="currentProduct=null;deleteProductPopup=false;"
								                    :is-fplus="true" :step-id="step.id" :funnel-id="step.funnel_id" />
							</div>

							<div class="popup_wrpr add_new_funnel_popup" :class="{active: cloneProductPopup}">
								<CloneProductPopup v-if="cloneProductPopup" :product="currentProduct"
								                   @cancel="currentProduct=null;cloneProductPopup=false"
								                   @done="productCreated($event)"
								                   :step-id="step.id" :funnel-id="step.funnel_id" :is-fplus="true"/>
							</div>

						</div>

						<!-- STEP CAN'T HAVE PRODUCTS -->
						<div class="panel funnels-panel products_panel" v-else>
							<div class="panel-head">
								<h2>Your step products</h2>
								<a class="btn disabled">Add a new product</a>
							</div>

							<div class="panel-body panel-body_2 empty-panel">
								<p>This step cannot have products, only <b>Order forms</b>, <b>Upsells</b> and <b>Downsells</b> may have products.</p>
							</div>
						</div>
					</div>
				</div>

			<div class="popup_right_side">
				<div class="flex layout-column">
					<div class="alert_box orange" style="margin:auto">
						<div class="icon">
							<inline-svg :src="require('@/assets/img/warning_icon.svg')" />
						</div>
						<span>Coming soon!</span>
					</div>
				</div>
				<!--                <product-preview v-show="showRightPanel" :products="products" :product="currentProduct"></product-preview>-->
			</div>
		</div>

		<CreateWProductPopup v-if="createProductOpen" :productsLength="obProducts.length + otherProducts.length"
		                     @close="createProductOpen=false" @done="productCreated"
		                     :step-id="step.id" :funnel-id="step.funnel_id" />

	<product-side-panel v-if="productOpen" in-editor :funnel-step="step" :products="products"
	                    @close="productOpen=false" :product="currentProduct"
	                    @done="updateProduct($event)"
	                    :delete="null" />
</div>
</template>

<script>
import Loading from "@/components/Loading";
import {types} from "@/helpers/stepTypes";
import {getSymbol} from "@/helpers/currencies";
import InfoIcon from "@/components/base/info-icon";
import VButton from "@/components/base/v-button";
import { Container, Draggable } from 'vue-smooth-dnd'
import CreateWProductPopup from "@/views/funnels/funnel-plus/steps/create_wproduct_popup";
import {applyDrag} from "@/helpers/sort";
import API from '@/api';
import ProductSidePanel from "@/views/funnels/funnel-plus/steps/plus-product-side-panel";
import ProductDeletePopup from "@/components/popups/delete/ProductDeletePopup";
import CloneProductPopup from "@/components/popups/clone_product_popup";

export default {
	name: "products-list-panel",
	components: {
		CloneProductPopup,
		ProductDeletePopup,
		ProductSidePanel, CreateWProductPopup, VButton, InfoIcon, Loading, Container, Draggable},
	props:['step', 'products'],
	mixins:[API],
	data() {
		return {
			cloneProductPopup: false,
			deleteProductPopup: false,
			productOpen: false,
			currentProduct: null,
			createProductOpen: false,
			obProducts: [],
			otherProducts: [],
			funnel: {},
		}
	},
	computed:{
		canHaveProducts() {
			if(this.step && this.step.type) {
				switch (parseInt(this.step.type)) {
					case types.DOWNSELL:
					case types.UPSELL:
					case types.ORDER_FORM:
						return true
					default:
						return false
				}
			} else return false
		},
		currencySymbol() {
			let symbol;
			if(this.funnel && (this.funnel ? this.funnel.currency_code : "") !== "") {
				symbol = getSymbol(this.funnel.currency_code);
			} else {
				symbol = '$';
			}
			return symbol
		},
	},
	watch:{
		products:{
			deep: true,
			handler(val) {
				this.obProducts = this.sortProducts(val.filter(item => item.is_ob));
				this.otherProducts = this.sortProducts(val.filter(item => !item.is_ob));
			}
		}
	},
	methods:{
		productCreated(p) {
			this.createProductOpen = false;
			this.cloneProductPopup = false;
			this.products.push(p);
		},
		productDeleted(p) {
			this.deleteProductPopup = false;
			this.currentProduct = null;
			let i = this.products.findIndex(x=>x.id===p.id)
			if (i>=0) this.products.splice(i, 1);
		},
		updateProduct(p){
			let oldP = this.products.find(x=>x.id===p.id)
			if (oldP) {
				Object.keys(p).forEach((key) => {
					this.$set(oldP, key, p[key]);
				});
			} else {
				this.products.push(p);
			}
		},
		getCycleType(type) {
			var string = '';
			switch (type) {
				case 1:
					string = ' day(s)';
					break;
				case 2:
					string = ' week(s)';
					break;
				case 3:
					string = ' month(s)';
					break;
				case 4:
					string = ' year(s)';
					break;
			}
			return string
		},
		sortProducts(arr) {
			function compare(a, b) {
				if (a['order_index'] < b['order_index']) return -1;
				if (a['order_index'] > b['order_index']) return 1;
				return 0;
			}
			return arr.sort(compare);
		},
		close(){
			this.$emit('close');
		},
		async onDrop (dropResult) {
			if(dropResult.removedIndex !== dropResult.addedIndex) {
				this.otherProducts = applyDrag(this.otherProducts, dropResult);

				let first = this.otherProducts[dropResult.removedIndex];
				let second = this.otherProducts[dropResult.addedIndex];

				let firstOrder = first['order_index'];
				let secondOrder = second['order_index'];

				first['order_index'] = secondOrder;
				second['order_index'] = firstOrder;

				this.otherProducts.forEach(async (item, index) => {
					item['order_index'] = index + 1;
					this.api.wsteps.patchProduct(this.step.funnel_id, this.step.id, item);
				});
			}
		},
		async init() {
			try {
				this.loading = true;

				if (!this.step) throw "no step found";

			} catch (e) {
				this.$notify({
					type:"warn",
					group: "main",
					title: "Something went wrong... Please try again later",
				});
				console.error("error", e);
			} finally {
				this.loading = false;
				this.show = true;
			}
		},
	},
	created() {
		if (this.products.length)
			this.obProducts = this.sortProducts(this.products.filter(item => item.is_ob));
		if (this.products.length)
			this.otherProducts = this.sortProducts(this.products.filter(item => !item.is_ob));

		this.init();
	}
}
</script>

<style lang="scss" scoped>
.products-list-panel {
	.popup_left_side {
		padding: 0;
	}
	.products_panel {
		padding: 25px;
		.products-header {
			margin-bottom: 15px;
		}
		.panel-item {
			width: 100%;
		}
	}
	.products-list-popup {
		position: absolute;
		right: 0;
		top: 0;
		background: #fff;
		max-width: 550px;
		width: 100%;
		height: 100%;
		display: flex;
		transition: 0.4s all ease-in-out;
		box-shadow: -5px 0 15px rgb(0 0 0 / 15%);
	}
}
</style>
